(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    (function () {
    function destaniyaPriceSliderInit(scope) {
      var root = scope || document;
      var components = root.querySelectorAll('price-facet-component');
      components.forEach(function (comp) {
        if (comp.dataset.dualSliderInit === 'true') return;
        comp.dataset.dualSliderInit = 'true';

        var slider = comp.querySelector('.price-slider');
        var minSlider = comp.querySelector('.price-slider__input--min');
        var maxSlider = comp.querySelector('.price-slider__input--max');
        var fill = comp.querySelector('.price-slider__fill');
        var minLabel = comp.querySelector('[data-min-label]');
        var maxLabel = comp.querySelector('[data-max-label]');
        var minInput = comp.querySelector('input[ref="minInput"]');
        var maxInput = comp.querySelector('input[ref="maxInput"]');
        if (!slider || !minSlider || !maxSlider || !minInput || !maxInput) return;

        var rangeMax = parseFloat(slider.getAttribute('data-range-max')) || parseFloat(minSlider.max) || 0;
        var symbol = comp.getAttribute('data-currency-symbol') || '$';

        function fmt(n) { return symbol + Math.round(n); }

        function readValues() {
          var minV = parseFloat(minSlider.value);
          var maxV = parseFloat(maxSlider.value);
          if (minV > maxV) { var t = minV; minV = maxV; maxV = t; }
          return { minV: minV, maxV: maxV };
        }

        function paint() {
          if (!rangeMax) return;
          var v = readValues();
          var leftPct = (v.minV / rangeMax) * 100;
          var rightPct = (v.maxV / rangeMax) * 100;
          fill.style.left = leftPct + '%';
          fill.style.right = (100 - rightPct) + '%';
          minLabel.textContent = fmt(v.minV);
          maxLabel.textContent = fmt(v.maxV);
        }

        function syncToInputs(triggerChange) {
          var v = readValues();
          // Reset slider DOM values in case of swap
          minSlider.value = v.minV;
          maxSlider.value = v.maxV;
          minInput.value = v.minV > 0 ? v.minV : '';
          maxInput.value = v.maxV < rangeMax ? v.maxV : '';
          paint();
          if (triggerChange) {
            minInput.dispatchEvent(new Event('change', { bubbles: true }));
            maxInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        minSlider.addEventListener('input', function () { paint(); });
        maxSlider.addEventListener('input', function () { paint(); });
        minSlider.addEventListener('change', function () { syncToInputs(true); });
        maxSlider.addEventListener('change', function () { syncToInputs(true); });

        // Smart thumb selection: when thumbs overlap, the user might want to drag whichever is closer
        slider.addEventListener('pointerdown', function (e) {
          var rect = slider.querySelector('.price-slider__track-wrap').getBoundingClientRect();
          var pct = (e.clientX - rect.left) / rect.width;
          var clickedVal = pct * rangeMax;
          var v = readValues();
          var distToMin = Math.abs(clickedVal - v.minV);
          var distToMax = Math.abs(clickedVal - v.maxV);
          if (distToMin < distToMax) {
            minSlider.style.zIndex = 3;
            maxSlider.style.zIndex = 2;
          } else {
            minSlider.style.zIndex = 2;
            maxSlider.style.zIndex = 3;
          }
        });

        paint();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { destaniyaPriceSliderInit(); });
    } else {
      destaniyaPriceSliderInit();
    }
    document.addEventListener('shopify:section:load', function (e) { destaniyaPriceSliderInit(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
